import { render } from "./ConfirmSubscriptionPage.vue?vue&type=template&id=795f7847&scoped=true"
import script from "./ConfirmSubscriptionPage.vue?vue&type=script&lang=js"
export * from "./ConfirmSubscriptionPage.vue?vue&type=script&lang=js"

import "./ConfirmSubscriptionPage.vue?vue&type=style&index=0&id=795f7847&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795f7847"]])

export default __exports__